import { Box, Avatar, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/Index";
import PropTypes from "prop-types";

interface AssigneeDetailsProps {
  firstName: string;
  lastName: string;
  profileImg: string | null;
}

export const AssigneeDetails: React.FC<AssigneeDetailsProps> = ({
  firstName,
  lastName,
  profileImg,
}) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mb: 1,
        padding: 1,
        border: `1px solid ${reduxTheme.primary_colors[800]}`,
        borderRadius: 1,
      }}
    >
      <Avatar
        alt="user picture"
        sx={{ width: 28, height: 28 }}
        src={profileImg ? profileImg : firstName.charAt(0).toUpperCase()}
      ></Avatar>
      <Typography variant="body1" sx={{ ml: 1, fontSize: ".8" }}>
        {`${firstName} ${lastName}`}
      </Typography>
    </Box>
  );
};

AssigneeDetails.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  profileImg: PropTypes.string,
};
